import React, { FC, PropsWithChildren, createContext } from 'react';

import { getThemeColors } from './helpers';
import { DEFAULT_THEME, ThemeProviderType } from './types';

export const ThemeProviderContext = createContext({
	state: {
		theme: DEFAULT_THEME,
	} as ThemeProviderType,
});

const ThemeProvider: FC<PropsWithChildren<ThemeProviderType>> = ({ theme, children }) => {
	const colors = getThemeColors(theme);

	return (
		<ThemeProviderContext.Provider value={{ state: { theme: theme ?? DEFAULT_THEME } }}>
			<style>
				{`
					:root {
						--theme-colors-100: ${colors['100']};
						--theme-colors-200: ${colors['200']};
						--theme-colors-300: ${colors['300']};
						--theme-colors-400: ${colors['400']};
						--theme-colors-500: ${colors['500']};
						--theme-colors-600: ${colors['600']};
						--theme-colors-700: ${colors['700']};
						--theme-colors-800: ${colors['800']};
						--theme-colors-900: ${colors['900']};

						--theme-colors-100-a0: ${colors['100'] + '00'};
						--theme-colors-100-a10: ${colors['100'] + '10'};
						--theme-colors-100-a15: ${colors['100'] + '15'};
						--theme-colors-100-a20: ${colors['100'] + '20'};
						--theme-colors-100-a50: ${colors['100'] + '50'};
						--theme-colors-100-a60: ${colors['100'] + '60'};
						--theme-colors-100-a70: ${colors['100'] + '70'};
						--theme-colors-100-a80: ${colors['100'] + '80'};
						--theme-colors-100-a90: ${colors['100'] + '90'};

						--theme-colors-300-a20: ${colors['300'] + '20'};
						--theme-colors-300-a50: ${colors['300'] + '50'};

						--theme-colors-900-a0: ${colors['900'] + '00'};
						--theme-colors-900-a10: ${colors['900'] + '10'};
						--theme-colors-900-a15: ${colors['900'] + '15'};
						--theme-colors-900-a20: ${colors['900'] + '20'};
						--theme-colors-900-a30: ${colors['900'] + '30'};
						--theme-colors-900-a50: ${colors['900'] + '50'};
						--theme-colors-900-a60: ${colors['900'] + '60'};
						--theme-colors-900-a70: ${colors['900'] + '70'};
						--theme-colors-900-a80: ${colors['900'] + '80'};
						--theme-colors-900-a90: ${colors['900'] + '90'};
					}
				`}
			</style>
			{children}
		</ThemeProviderContext.Provider>
	);
};

export default ThemeProvider;
